<template>
    <ul class="info-list">
        <slot></slot>
    </ul>
</template>
<style lang="scss">
.info-list {
    margin: 0;
}
</style>
